
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexVkWPnt9MFFMeta } from "/app/pages/a-pratica/index.vue?macro=true";
import { default as indexi8nCATZISJMeta } from "/app/pages/admin/index.vue?macro=true";
import { default as indexlK8akWX7smMeta } from "/app/pages/dicas/index.vue?macro=true";
import { default as index3JoI9b624fMeta } from "/app/pages/entrar/index.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as indexAX0erJK0UsMeta } from "/app/pages/lancamento/index.vue?macro=true";
import { default as indexRFTffsyNgjMeta } from "/app/pages/o-tutorial/index.vue?macro=true";
import { default as indexUZGBHiTgaVMeta } from "/app/pages/quiz/index.vue?macro=true";
import { default as indexzLncJhSlQ8Meta } from "/app/pages/ranqueamento/index.vue?macro=true";
import { default as indexjVdhfKiUmVMeta } from "/app/pages/recuperar-senha/index.vue?macro=true";
import { default as indexAM6uD0XgIWMeta } from "/app/pages/registrar/index.vue?macro=true";
import { default as index9lftHPpaZGMeta } from "/app/pages/sobre/index.vue?macro=true";
import { default as indexj81Xy6TbOHMeta } from "/app/pages/termos-e-condicoes/index.vue?macro=true";
import { default as index3Gq4tMcM7aMeta } from "/app/pages/tutorial/index.vue?macro=true";
export default [
  {
    name: "a-pratica",
    path: "/a-pratica",
    meta: indexVkWPnt9MFFMeta || {},
    component: () => import("/app/pages/a-pratica/index.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: indexi8nCATZISJMeta || {},
    component: () => import("/app/pages/admin/index.vue")
  },
  {
    name: "dicas",
    path: "/dicas",
    component: () => import("/app/pages/dicas/index.vue")
  },
  {
    name: "entrar",
    path: "/entrar",
    meta: index3JoI9b624fMeta || {},
    component: () => import("/app/pages/entrar/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "lancamento",
    path: "/lancamento",
    meta: indexAX0erJK0UsMeta || {},
    component: () => import("/app/pages/lancamento/index.vue")
  },
  {
    name: "o-tutorial",
    path: "/o-tutorial",
    component: () => import("/app/pages/o-tutorial/index.vue")
  },
  {
    name: "quiz",
    path: "/quiz",
    component: () => import("/app/pages/quiz/index.vue")
  },
  {
    name: "ranqueamento",
    path: "/ranqueamento",
    component: () => import("/app/pages/ranqueamento/index.vue")
  },
  {
    name: "recuperar-senha",
    path: "/recuperar-senha",
    meta: indexjVdhfKiUmVMeta || {},
    component: () => import("/app/pages/recuperar-senha/index.vue")
  },
  {
    name: "registrar",
    path: "/registrar",
    meta: indexAM6uD0XgIWMeta || {},
    component: () => import("/app/pages/registrar/index.vue")
  },
  {
    name: "sobre",
    path: "/sobre",
    component: () => import("/app/pages/sobre/index.vue")
  },
  {
    name: "termos-e-condicoes",
    path: "/termos-e-condicoes",
    meta: indexj81Xy6TbOHMeta || {},
    component: () => import("/app/pages/termos-e-condicoes/index.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/app/pages/tutorial/index.vue")
  }
]